import TaskListWrapper from "../TaskListWrapper";

export default function TodoList({ list, setList }) {
  return <TaskListWrapper setList={setList} data={list} />;
}
